import request from 'utils/request';

export default {
  send(payload) {
    return request.post('/api/contact-form', payload);
  },
};
